/* eslint-disable sort-keys */
import textStyles from "../constants/textStyles";

export default {
    Select: {
        parts: [ "icon", "field" ],
        baseStyle: {},
        sizes: {},
        variants: {
            default: {
                field: {
                    ...textStyles.p1,
                    mb: "0",
                    borderRadius: "5",
                    px: "4",
                    border: "1px solid",
                    borderColor: "secondary.100",
                    transition:
                        " border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
                    h: "12",
                    fontWeight: "600",
                    _placeholder: { opacity: "0.3" },
                    _hover: { borderColor: "secondary.200", _disabled: { borderColor: "secondary.100" } },
                    _focus: { borderColor: "primary.400", borderWidth:"2px", _hover: { borderColor: "primary.400" } },
                    _active: { borderColor: "primary.400", borderWidth:"2px", _hover: { borderColor: "primary.400" } },
                    _disabled: { borderColor: "secondary.100", bgColor: "secondary.100", opacity: "0.7", _hover: { borderColor: "secondary.100" } }
                },
            },
            unstyledInline: {
                field: {
                    display: "inline-block",
                    width: "full",
                    bg: "transparent",
                    pl: 0,
                    height: "auto",            
                }
            },
            unstyledBrand: {
                field: {
                    display: "inline-block",
                    width: "full",
                    bg: "transparent",
                    pl: 0,
                    height: "auto",
                    color: "brand.default"            
                }
            },
            outline: {
                field: {
                    fontSize: "small",
                    h: "10",
                    p: ({ space }) => `${space[2]} ${space[3]}`,
                    fontWeight: "400",
                    backgroundColor: "white",
                    border: "1px solid",
                    borderColor: "secondary.50",
                    borderRadius: "5",
                    transition:" border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",  
                    _active: { boxShadow: "none", borderColor: "focus" },
                    _focus: { boxShadow: "none", borderColor: "focus" },
                    _placeholder: { color: "dark-5" },
                    _disabled: {
                        background: "secondary.50",
                        color: "dark-6",
                        _hover: { borderColor: "light-4" },
                    },
                }
            },
            outlineThin: {
                field: {
                    h: "auto",
                    fontSize: "xsmall",
                    py: 2,
                    pl: 3,
                    fontWeight: "400",
                    backgroundColor: "white",
                    border: "1px solid",
                    borderColor: "light-2",
                    borderRadius: "5",
                    transition:" border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",  
                    _active: { boxShadow: "none", borderColor: "focus" },
                    _focus: { boxShadow: "none", borderColor: "focus" },
                    _placeholder: { color: "dark-5" },
                    _disabled: {
                        background: "secondary.50",
                        color: "dark-6",
                        _hover: { borderColor: "light-4" },
                    },
                },
                icon: {
                    stroke: "light-2",
                    iconColor: "light-2",
                    fill: "light-2"
                }
            }
        },
        defaultProps: {
            variant: "default"
        },
    }
};

